<template>
  <a-modal
    :wrapClassName="disabled ? 'ps-see-form-modal' : ''"
    :title="title"
    width="40%"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :maskClosable="false"
    :keyboard="false"
    @cancel="handleCancel"
    @ok="submit"
    :ok-text="saveText"
    cancel-text="取消"
    :destroyOnClose="true"
  >
    <div>
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="标题名称" prop="titleName">
          <div class="flex">
            <a-select
              v-model="form.titleName"
              :disabled="disabled"
              @change="choiceChange"
            >
              <a-select-option :value="item.text" v-for="item in btlist">{{
                item.title
              }}</a-select-option>
            </a-select>
          </div>
        </a-form-model-item>
        <a-form-model-item label="类别" prop="szType">
          <div class="flex">
            <a-select
              v-model="form.szType"
              :disabled="disabled"
              @change="handleChange"
            >
              <a-select-option :value="item.text" v-for="item in jblists">{{
                item.title
              }}</a-select-option>
            </a-select>
            <template v-if="form.szType == '其他'">
              <a-input
                v-model="form.otherType"
                :disabled="disabled"
                class="ipt-other"
              />
            </template>
          </div>
        </a-form-model-item>
        <!--  -->
        <a-form-model-item
          label="专业大类"
          v-if="code == 'kcsz' && iskc"
          prop="basicMajorCategory"
        >
          <div class="flex">
            <a-select
              show-search
              v-model="form.basicMajorCategory"
              :disabled="disabled"
              option-filter-prop="children"
              @change="handleChange1"
              :filter-option="filterOption"
            >
              <a-select-option value="">请选择专业大类</a-select-option>
              <a-select-option
                v-for="item in zydlList"
                :key="item.id"
                :value="item.id"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
          </div>
        </a-form-model-item>
        <a-form-model-item
          label="专业子类"
          v-if="code == 'kcsz' && iskc"
          prop="basicMajorSubclass"
        >
          <div class="flex">
            <a-select
              show-search
              v-model="form.basicMajorSubclass"
              :disabled="disabled"
              @change="handleChange2"
              :filter-option="filterOption"
            >
              <a-select-option value="">请选择专业子类</a-select-option>
              <a-select-option
                v-for="item in zyzlList"
                :key="item.id"
                :value="item.id"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
          </div>
        </a-form-model-item>
        <!-- v-if="code == 'kcsz' && iskc" -->
        <a-form-model-item
          label="专业"
          v-if="code == 'kcsz' && iskc"
          prop="basicMajor"
        >
          <div class="flex">
            <a-select
              show-search
              v-model="form.basicMajor"
              :disabled="disabled"
              :filter-option="filterOption"
              @blur="changeupdate"
            >
              <a-select-option value="">请选择专业</a-select-option>
              <a-select-option
                v-for="item in zyList"
                :key="item.id"
                :value="item.id"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
          </div>
        </a-form-model-item>
        <a-form-model-item
          label="课程名称"
          v-if="code == 'kcsz' && iskc"
          prop="cName"
        >
          <a-input
            v-model="form.cName"
            @blur="changeupdate"
            :disabled="disabled"
            placeholder="请输入课程名称"
          />
        </a-form-model-item>
        <a-form-model-item
          label="类型"
          v-if="
            code == 'kcsz' &&
            iskc &&
            form.szType &&
            form.szType != '' &&
            form.szType.indexOf('金课') != '-1'
          "
          prop="jkType"
        >
          <a-select
            v-model="form.jkType"
            :disabled="disabled"
            placeholder="请选择类型"
            @change="changeupdate"
          >
            <a-select-option
              v-for="item in lxList"
              :key="item.text || item.value"
              :value="item.text || item.value"
            >
              {{ item.title || item.text }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item
          label="赛项名称"
          v-if="code == 'szkc' && isbs"
          prop="cName"
        >
          <a-input
            v-model="form.cName"
            :disabled="disabled"
            @blur="changeupdate"
            placeholder="请输入赛项名称"
          />
        </a-form-model-item>
        <a-form-model-item
          label="课程名称"
          v-if="code == 'szkc' && !isbs"
          prop="cName"
        >
          <a-input
            v-model="form.cName"
            :disabled="disabled"
            @blur="changeupdate"
            placeholder="请输入课程名称"
          />
        </a-form-model-item>
        <a-form-model-item
          label="案例名称"
          v-if="
            code == 'kcsz' &&
            form.szType &&
            form.szType != '' &&
            form.szType.indexOf('案例') != '-1'
          "
          prop="cName"
        >
          <div class="flex">
            <a-input
              v-model="form.cName"
              :disabled="disabled"
              @blur="changeupdate"
              placeholder="请输入案例名称"
            />
          </div>
        </a-form-model-item>
        <a-form-model-item label="年份" prop="activityYear">
          <a-date-picker
            placeholder="请选择年份"
            :disabled="disabled"
            v-model="form.activityYear"
            :open="yearShowOne"
            :locale="locale"
            :format="'YYYY'"
            mode="year"
            @openChange="openChangeOne"
            @panelChange="panelChangeOne"
            @change="handleClearAcquireYear"
          />
        </a-form-model-item>
        <!-- && form.szType && form.szType != '' && form.szType.indexOf('示范课程') != '-1' -->
        <a-form-model-item
          label="认定级别"
          v-if="code == 'szkc' || code == 'kcsz'"
          prop="levelType"
        >
          <div class="flex">
            <a-select
              v-model="form.levelType"
              :disabled="disabled"
              @change="changeupdate"
              placeholder="请选择认定级别"
            >
              <a-select-option
                :value="item.text"
                v-for="item in jblist"
                :key="item.text"
                >{{ item.title }}</a-select-option
              >
              <!-- <a-select-option value="其他" >{{
                item.title
              }}</a-select-option> -->
            </a-select>
            <template v-if="form.levelType == '其他'">
              <a-input
                v-model="form.otherLevelType"
                :disabled="disabled"
                @blur="changeupdate"
                class="ipt-other"
              />
            </template>
          </div>
        </a-form-model-item>
        <!-- <a-form-model-item label="类型" v-if="code == 'kcsz' && !iskc" prop="category">
          <a-select v-model="form.category">
            <a-select-option v-for="item in lxList" :key="item.text" :value="item.text">
              {{ item.title }}
            </a-select-option>
          </a-select>
        </a-form-model-item> -->
        <a-form-model-item
          label="奖项"
          v-if="code == 'szkc' && isbs"
          prop="award"
        >
          <div class="flex">
            <a-input
              v-model="form.award"
              :disabled="disabled"
              @blur="changeupdate"
              placeholder="请输入奖项"
            />
          </div>
        </a-form-model-item>
        <a-form-model-item label="数量" prop="num">
          <a-input-number
            v-model="form.num"
            :disabled="disabled"
            min="1"
            precision="0"
            @blur="blurValue"
          />
        </a-form-model-item>
      </a-form-model>
    </div>
  </a-modal>
</template>

<script>
import { getAction, postAction, putAction } from "@/api/index";
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
import BaseEditor from "@/components/common/BaseEditor.vue";
moment.locale("zh-cn");
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 16 },
      other: "",
      form: {
        applyId: "",
        title: "",
        activityYear: "",
        // achievementType: "",
        num: "",
        szType: "",
        // content: "",
        // courseType: "",
        otherType: "",
        titleName: "",
        levelType: "",
        otherLevelType: "",
        award: "",
        basicMajorCategory: null,
        basicMajorSubclass: null,
        basicMajor: null,
        cName: "",
        jkType: "",
        category: "",
      },
      btlist: [],
      zydlList: [],
      zyzlList: [],
      zyList: [],
      disabled: false,
      rules: {
        // titleName: [
        //   {
        //     required: true,
        //     message: "请选择标题名称",
        //     trigger: "change",
        //   },
        // ],
        // szType: [
        //   {
        //     required: true,
        //     message: "请输入类别",
        //     trigger: "change",
        //   },
        // ],
        // activityYear: [
        //   {
        //     validator: (rule, value, callback) => {
        //       if (this.form.activityYear != '') {
        //         callback(); // 验证通过
        //       } else {
        //         callback(new Error('请选择年份'));
        //       }
        //     },
        //     required: true,
        //     message: "请选择年份",
        //     //          type: 'string',
        //     trigger: "change",
        //   },
        // ],
        // achievementType: [
        //   {
        //     required: true,
        //     message: "请输入成果类型",
        //     trigger: "change",
        //   },
        // ],
        // num: [
        //   {
        //     required: true,
        //     message: "请输入数量",
        //     trigger: "blur",
        //   },
        // ],
      },
      rules1: {
        titleName: [
          {
            required: true,
            message: "请选择标题名称",
            trigger: "change",
          },
        ],
        szType: [
          {
            required: true,
            message: "请输入类别",
            trigger: "change",
          },
        ],
        activityYear: [
          {
            validator: (rule, value, callback) => {
              if (this.form.activityYear != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请选择年份"));
              }
            },
            required: true,
            message: "请选择年份",
            //          type: 'string',
            trigger: "change",
          },
        ],
        // achievementType: [
        //   {
        //     required: true,
        //     message: "请输入成果类型",
        //     trigger: "change",
        //   },
        // ],
        num: [
          {
            required: true,
            message: "请输入数量",
            trigger: "blur",
          },
        ],
      },
      rules2: {
        titleName: [
          {
            required: true,
            message: "请选择标题名称",
            trigger: "change",
          },
        ],
        szType: [
          {
            required: true,
            message: "请选择类别",
            trigger: "change",
          },
        ],
        activityYear: [
          {
            validator: (rule, value, callback) => {
              if (this.form.activityYear != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请选择年份"));
              }
            },
            required: true,
            message: "请选择年份",
            //          type: 'string',
            trigger: "change",
          },
        ],
        // achievementType: [
        //   {
        //     required: true,
        //     message: "请输入成果类型",
        //     trigger: "change",
        //   },
        // ],
        cName: [
          {
            validator: (rule, value, callback) => {
              if (this.form.cName != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请输入赛项名称"));
              }
            },
            required: true,
            message: "请输入赛项名称",
            trigger: "blur",
          },
        ],
        levelType: [
          {
            validator: (rule, value, callback) => {
              if (this.form.levelType != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请选择认定级别"));
              }
            },
            required: true,
            message: "请选择认定级别",
            trigger: "change",
          },
        ],
        award: [
          {
            validator: (rule, value, callback) => {
              if (this.form.award != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请输入奖项"));
              }
            },
            required: true,
            message: "请输入奖项",
            trigger: "blur",
          },
        ],
        num: [
          {
            validator: (rule, value, callback) => {
              if (this.form.num != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请输入数量"));
              }
            },
            required: true,
            message: "请输入数量",
            trigger: "blur",
          },
        ],
      },
      rules3: {
        titleName: [
          {
            required: true,
            message: "请选择标题名称",
            trigger: "change",
          },
        ],
        szType: [
          {
            required: true,
            message: "请输入类别",
            trigger: "change",
          },
        ],
        activityYear: [
          {
            validator: (rule, value, callback) => {
              if (this.form.activityYear != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请选择年份"));
              }
            },
            required: true,
            message: "请选择年份",
            //          type: 'string',
            trigger: "change",
          },
        ],
        // achievementType: [
        //   {
        //     required: true,
        //     message: "请输入成果类型",
        //     trigger: "change",
        //   },
        // ],
        cName: [
          {
            validator: (rule, value, callback) => {
              if (this.form.cName != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请输入课程名称"));
              }
            },
            required: true,
            message: "请输入课程名称",
            trigger: "blur",
          },
        ],
        levelType: [
          {
            validator: (rule, value, callback) => {
              if (this.form.levelType != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请选择认定级别"));
              }
            },
            required: true,
            message: "请选择认定级别",
            trigger: "change",
          },
        ],
        // num: [
        //   {
        //     validator: (rule, value, callback) => {
        //       if (this.form.num != '') {
        //         callback(); // 验证通过
        //       } else {
        //         callback(new Error('请输入数量'));
        //       }
        //      },
        //     required: true,
        //     message: "请输入数量",
        //     trigger: "blur",
        //   },
        // ],
      },
      rules4: {
        titleName: [
          {
            required: true,
            message: "请选择标题名称",
            trigger: "change",
          },
        ],
        szType: [
          {
            required: true,
            message: "请输入类别",
            trigger: "change",
          },
        ],
        basicMajorCategory: [
          {
            validator: (rule, value, callback) => {
              if (this.form.basicMajorCategory != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请选择专业大类"));
              }
            },
            required: true,
            message: "请选择专业大类",
            trigger: "change",
          },
        ],
        basicMajorSubclass: [
          {
            validator: (rule, value, callback) => {
              if (this.form.basicMajorSubclass != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请选择专业子类"));
              }
            },
            required: true,
            message: "请选择专业子类",
            trigger: "change",
          },
        ],
        basicMajor: [
          {
            validator: (rule, value, callback) => {
              if (this.form.basicMajor != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请选择专业"));
              }
            },
            required: true,
            message: "请选择专业",
            trigger: "change",
          },
        ],
        cName: [
          {
            validator: (rule, value, callback) => {
              if (this.form.cName != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请输入课程名称"));
              }
            },
            required: true,
            message: "请输入课程名称",
            trigger: "blur",
          },
        ],
        levelType: [
          {
            validator: (rule, value, callback) => {
              if (this.form.levelType != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请选择认定级别"));
              }
            },
            required: true,
            message: "请选择认定级别",
            trigger: "change",
          },
        ],
        activityYear: [
          {
            validator: (rule, value, callback) => {
              if (this.form.activityYear != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请选择年份"));
              }
            },
            required: true,
            message: "请选择年份",
            //          type: 'string',
            trigger: "change",
          },
        ],
        // achievementType: [
        //   {
        //     required: true,
        //     message: "请输入成果类型",
        //     trigger: "change",
        //   },
        // ],
        // num: [
        //   {
        //     required: true,
        //     message: "请输入数量",
        //     trigger: "blur",
        //   },
        // ],
      },
      rules5: {
        titleName: [
          {
            required: true,
            message: "请选择标题名称",
            trigger: "change",
          },
        ],
        szType: [
          {
            required: true,
            message: "请输入类别",
            trigger: "change",
          },
        ],
        basicMajorCategory: [
          {
            validator: (rule, value, callback) => {
              if (this.form.basicMajorCategory != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请选择专业大类"));
              }
            },
            required: true,
            message: "请选择专业大类",
            trigger: "change",
          },
        ],
        basicMajorSubclass: [
          {
            validator: (rule, value, callback) => {
              if (this.form.basicMajorSubclass != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请选择专业子类"));
              }
            },
            required: true,
            message: "请选择专业子类",
            trigger: "change",
          },
        ],
        basicMajor: [
          {
            validator: (rule, value, callback) => {
              if (this.form.basicMajor != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请选择专业"));
              }
            },
            required: true,
            message: "请选择专业",
            trigger: "change",
          },
        ],
        cName: [
          {
            validator: (rule, value, callback) => {
              if (this.form.cName != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请输入课程名称"));
              }
            },
            required: true,
            message: "请输入课程名称",
            trigger: "blur",
          },
        ],
        jkType: [
          {
            validator: (rule, value, callback) => {
              if (this.form.jkType != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请选择类型"));
              }
            },
            required: true,
            message: "请选择类型",
            trigger: "change",
          },
        ],
        levelType: [
          {
            validator: (rule, value, callback) => {
              if (this.form.levelType != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请选择认定级别"));
              }
            },
            required: true,
            message: "请选择认定级别",
            trigger: "change",
          },
        ],
        activityYear: [
          {
            validator: (rule, value, callback) => {
              if (this.form.activityYear != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请选择年份"));
              }
            },
            required: true,
            message: "请选择年份",
            //          type: 'string',
            trigger: "change",
          },
        ],
        // achievementType: [
        //   {
        //     required: true,
        //     message: "请输入成果类型",
        //     trigger: "change",
        //   },
        // ],
        // num: [
        //   {
        //     required: true,
        //     message: "请输入数量",
        //     trigger: "blur",
        //   },
        // ],
      },
      rules6: {
        titleName: [
          {
            required: true,
            message: "请选择标题名称",
            trigger: "change",
          },
        ],
        szType: [
          {
            required: true,
            message: "请输入类别",
            trigger: "change",
          },
        ],
        basicMajorCategory: [
          {
            validator: (rule, value, callback) => {
              if (this.form.basicMajorCategory != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请选择专业大类"));
              }
            },
            required: true,
            message: "请选择专业大类",
            trigger: "change",
          },
        ],
        basicMajorSubclass: [
          {
            validator: (rule, value, callback) => {
              if (this.form.basicMajorCategory != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请选择专业子类"));
              }
            },
            required: true,
            message: "请选择专业子类",
            trigger: "change",
          },
        ],
        basicMajor: [
          {
            validator: (rule, value, callback) => {
              if (this.form.basicMajorCategory != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请选择专业"));
              }
            },
            required: true,
            message: "请选择专业",
            trigger: "change",
          },
        ],
        cName: [
          {
            validator: (rule, value, callback) => {
              if (this.form.cName != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请输入课程名称"));
              }
            },
            required: true,
            message: "请输入课程名称",
            trigger: "blur",
          },
        ],
        activityYear: [
          {
            validator: (rule, value, callback) => {
              if (this.form.activityYear != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请选择年份"));
              }
            },
            required: true,
            message: "请选择年份",
            //          type: 'string',
            trigger: "change",
          },
        ],
        levelType: [
          {
            validator: (rule, value, callback) => {
              if (this.form.levelType != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请选择认定级别"));
              }
            },
            required: true,
            message: "请选择认定级别",
            trigger: "change",
          },
        ],
        // num: [
        //   {
        //     required: true,
        //     message: "请输入数量",
        //     trigger: "blur",
        //   },
        // ],
      },
      rules7: {
        titleName: [
          {
            required: true,
            message: "请选择标题名称",
            trigger: "change",
          },
        ],
        szType: [
          {
            required: true,
            message: "请输入类别",
            trigger: "change",
          },
        ],
        activityYear: [
          {
            validator: (rule, value, callback) => {
              if (this.form.activityYear != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请选择年份"));
              }
            },
            required: true,
            message: "请选择年份",
            //          type: 'string',
            trigger: "change",
          },
        ],
        cName: [
          {
            validator: (rule, value, callback) => {
              if (this.form.cName != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请输入案例名称"));
              }
            },
            required: true,
            message: "请输入案例名称",
            trigger: "blur",
          },
        ],
        // achievementType: [
        //   {
        //     required: true,
        //     message: "请输入成果类型",
        //     trigger: "change",
        //   },
        // ],
        // category: [
        //   {
        //     required: true,
        //     message: "请选择类型",
        //     trigger: "change",
        //   },
        // ],
        levelType: [
          {
            validator: (rule, value, callback) => {
              if (this.form.levelType != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请选择认定级别"));
              }
            },
            required: true,
            message: "请选择认定级别",
            trigger: "change",
          },
        ],
        // num: [
        //   {
        //     required: true,
        //     message: "请输入数量",
        //     trigger: "blur",
        //   },
        // ],
      },
      yearShowOne: false,
      zh_CN,
      locale,
      applyType: 1,
      // 添加还是编辑
      type: "",
      // 弹框标题
      title: "",
      xwlist: [],
      jblist: [],
      jblists: [],
      kclist: [],
      ishow: false,
      ifirst: true,
      code: "",
      isbs: false,
      iskc: false,
      lxList: [],
      taskId: null,
      detailId: null,
      saveText: "保存",
      teacherdata: {},
    };
  },
  components: { BaseEditor },
  mounted() {
    // console.log("111111");
    // console.log(this.rules);
  },
  methods: {
    changeupdate() {
      this.$forceUpdate();
    },
    zydl() {
      getAction("/infrastructure/basicMajorCategory/allList", {}).then(
        (res) => {
          console.log(res);
          if (res.code === 200) {
            let data = res.result;
            if (data) {
              this.zydlList = data;
            }
          }
        }
      );
    },
    handleChange1(value) {
      this.zyzl(value);
      this.form.basicMajorSubclass = "";
      this.form.basicMajor = "";
      this.zyList = [];
      this.$forceUpdate();
    },
    handleChange2(value) {
      this.zylist(value);
      this.form.basicMajor = "";
      this.$forceUpdate();
    },
    zyzl(id) {
      getAction("/infrastructure/basicMajorSubclass/queryByCategoryId", {
        gategoryId: id,
      }).then((res) => {
        //			console.log(res);
        if (res.code === 200) {
          let data = res.result;
          if (data) {
            this.zyzlList = data;
          }
        }
      });
    },
    zylist(id) {
      getAction("/infrastructure/basicMajor/queryBySubclassId", {
        subclassId: id,
      }).then((res) => {
        console.log(res);
        if (res.code === 200) {
          let data = res.result;
          if (data) {
            this.zyList = data;
          }
        }
      });
    },
    getlxlist() {
      getAction("/baseCommon/getDictItemsByCode?code=jk_type").then((res) => {
        if (res.code == 200) {
          this.lxList = res.result;
        }
      });
    },
    getbtlist() {
      getAction("/baseCommon/getDictItemsByCode?code=szkcandkcsz").then(
        (res) => {
          if (res.code == 200) {
            this.btlist = res.result;
          }
        }
      );
    },
    handleClearAcquireYear(val) {
      this.form.activityYear = ""; // 或者适当的空值，根据你的业务需求
      this.$forceUpdate();
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    blurValue() {
      if (this.form.amount == "1") {
        this.ifirst = true;
      } else {
        this.ifirst = false;
        this.form.content = "";
      }
      this.$forceUpdate();
    },
    choiceChange() {
      if (this.form.titleName == "思政课程开展情况") {
        this.code = "szkc";
      } else if (this.form.titleName == "课程思政开展情况") {
        this.code = "kcsz";
      } else {
        this.code = "szdjy";
      }
      this.form.szType = "";
      this.form.otherType = "";
      this.form.levelType = "";
      this.form.otherLevelType = "";
      this.form.award = "";
      this.form.basicMajorCategory = "";
      this.form.basicMajorSubclass = "";
      this.form.basicMajor = "";
      this.form.cName = "";
      this.form.jkType = "";
      this.form.category = "";
      // this.form.resetFields();
      this.isbs = false;
      this.iskc = false;
      this.jblists = [];
      this.$forceUpdate();
      this.getcgjb();
    },
    choiceChanges() {
      if (this.form.titleName == "思政课程开展情况") {
        this.code = "szkc";
      } else if (this.form.titleName == "课程思政开展情况") {
        this.code = "kcsz";
      } else {
        this.code = "szdjy";
      }
      this.isbs = false;
      this.iskc = false;
      this.jblists = [];
      this.$forceUpdate();
      this.getcgjb();
    },
    handleChange() {
      // console.log(this.form.achievementType);
      this.rules = {};
      this.$forceUpdate();
      let buildName = this.form.szType;
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.clearValidate(); // 确保校验状态清除
      }
      if (this.code == "szkc") {
        if (
          buildName.indexOf("大赛") != -1 ||
          buildName.indexOf("比赛") != -1 ||
          buildName.indexOf("竞赛") != -1 ||
          buildName.indexOf("赛事") != -1
        ) {
          this.isbs = true;
          console.log(2);
          this.rules = this.rules2;
        } else {
          this.isbs = false;
          console.log(3);
          this.rules = this.rules3;
        }
      } else if (this.code == "kcsz") {
        if (buildName.indexOf("金课") != -1) {
          this.iskc = true;
          this.$set(this.form, "jkType", this.form.jkType || "");
          console.log(5);
          this.rules = this.rules5;
        } else if (buildName.indexOf("精品课") != -1) {
          this.iskc = true;
          console.log(4);
          this.rules = this.rules4;
        } else if (buildName.indexOf("示范课程") != -1) {
          this.iskc = true;
          console.log(6);
          this.rules = this.rules6;
        } else {
          this.iskc = false;
          console.log(7);
          this.rules = this.rules7;
        }
      } else {
        this.isbs = false;
        this.iskc = false;
        this.rules = this.rules1;
      }
      this.$forceUpdate();
      //  this.$refs.ruleForm.clearValidate();
      // if (this.form.achievementType == "SZKC") {
      //   this.ishow = true;
      // } else {
      //   this.ishow = false;
      //   this.form.courseType = "";
      // }
    },
    openChangeOne(status) {
      if (status) {
        this.yearShowOne = true;
      }
    },
    panelChangeOne(value) {
      //   	      console.log(value,"111111");
      // this.form.activityYear = value;
      const year = moment(value).format("YYYY");
      this.form.activityYear = year + "";
      this.yearShowOne = false;
      this.$refs.ruleForm.clearValidate("activityYear");
      // this.yearShowOne = false;
    },
    init(type, record, taskId, detailId) {
      this.type = type;
      this.visible = true;
      this.disabled = false;
      this.getxwlist();
      this.getlxlist();
      this.getbtlist();
      this.zydl();
      // this.getkclist();
      if (type == "add") {
        this.rules = this.rules1;
        this.isbs = false;
        this.iskc = false;
        this.code = "";
        this.form = {
          applyId: record.id,
          activityYear: new Date().getFullYear() + "",
          szType: "",
          otherType: "",
          num: "",
          titleName: "",
          levelType: "",
          otherLevelType: "",
          award: "",
          basicMajorCategory: null,
          basicMajorSubclass: null,
          basicMajor: null,
          cName: "",
          jkType: "",
          category: "",
        };
        this.title = "新增思政课程与课程思政大格局";
      } else if (type == "edit") {
        this.title = "编辑思政课程与课程思政大格局";
        this.form = {
          // title: record.title,
          // achievementType: record.achievementType,
          // amount: record.amount,
          szType: record.szType,
          // courseType: record.courseType,
          applyId: record.applyId,
          activityYear: record.activityYear,
          id: record.id,
          // content: record.content,
          num: record.num,
          otherType: record.otherType,
          titleName: record.titleName,
          cName: record.cName,
          levelType: record.levelType,
          otherLevelType: record.otherLevelType,
          award: record.award,
          jkType: record.jkType,
          category: record.category,
          basicMajorCategory: record.basicMajorCategory,
          basicMajorSubclass: record.basicMajorSubclass,
          basicMajor: record.basicMajor,
        };
        this.choiceChanges();
        this.handleChange();
        if (
          record.basicMajorCategory != "" &&
          record.basicMajorCategory != null
        ) {
          this.zyzl(record.basicMajorCategory);
        }
        if (
          record.basicMajorSubclass != "" &&
          record.basicMajorSubclass != null
        ) {
          this.zylist(record.basicMajorSubclass);
        }
        // if (record.amount == "1") {
        //   this.ifirst = true;
        // } else {
        //   this.ifirst = false;
        //   this.form.content = "";
        // }
        // if (record.achievementType == "SZKC") {
        //   this.ishow = true;
        // } else {
        //   this.ishow = false;
        //   this.form.courseType = "";
        // }
        //       if (record.content!='' && record.content!=null ){
        //           this.$nextTick(() => {
        //             this.$refs.baseEditor[0].value = record.content;
        //           })
        //       }
        this.teacherdata = record;
      } else if (type === "audit-edit") {
        this.title = "编辑思政课程与课程思政大格局";
        this.saveText = "提交";
        this.taskId = taskId;
        this.detailId = detailId;
        this.form = {
          // title: record.title,
          // achievementType: record.achievementType,
          // amount: record.amount,
          szType: record.szType,
          // courseType: record.courseType,
          applyId: record.applyId,
          activityYear: record.activityYear,
          id: record.id,
          // content: record.content,
          num: record.num,
          otherType: record.otherType,
          titleName: record.titleName,
          cName: record.cName,
          levelType: record.levelType,
          otherLevelType: record.otherLevelType,
          award: record.award,
          jkType: record.jkType,
          category: record.category,
          basicMajorCategory: record.basicMajorCategory,
          basicMajorSubclass: record.basicMajorSubclass,
          basicMajor: record.basicMajor,
        };
        this.choiceChanges();
        this.handleChange();
        if (
          record.basicMajorCategory != "" &&
          record.basicMajorCategory != null
        ) {
          this.zyzl(record.basicMajorCategory);
        }
        if (
          record.basicMajorSubclass != "" &&
          record.basicMajorSubclass != null
        ) {
          this.zylist(record.basicMajorSubclass);
        }
        // if (record.amount == "1") {
        //   this.ifirst = true;
        // } else {
        //   this.ifirst = false;
        //   this.form.content = "";
        // }
        // if (record.achievementType == "SZKC") {
        //   this.ishow = true;
        // } else {
        //   this.ishow = false;
        //   this.form.courseType = "";
        // }
        //       if (record.content!='' && record.content!=null ){
        //           this.$nextTick(() => {
        //             this.$refs.baseEditor[0].value = record.content;
        //           })
        //       }
      } else if (type == "see") {
        this.title = "查看思政课程与课程思政大格局";
        this.disabled = true;
        this.saveText = "关闭";
        this.form = {
          // title: record.title,
          // achievementType: record.achievementType,
          // amount: record.amount,
          szType: record.szType,
          // courseType: record.courseType,
          applyId: record.applyId,
          activityYear: record.activityYear,
          id: record.id,
          // content: record.content,
          num: record.num,
          otherType: record.otherType,
          titleName: record.titleName,
          cName: record.cName,
          levelType: record.levelType,
          otherLevelType: record.otherLevelType,
          award: record.award,
          jkType: record.jkType,
          category: record.category,
          basicMajorCategory: record.basicMajorCategory,
          basicMajorSubclass: record.basicMajorSubclass,
          basicMajor: record.basicMajor,
        };
        this.choiceChanges();
        this.handleChange();
        if (
          record.basicMajorCategory != "" &&
          record.basicMajorCategory != null
        ) {
          this.zyzl(record.basicMajorCategory);
        }
        if (
          record.basicMajorSubclass != "" &&
          record.basicMajorSubclass != null
        ) {
          this.zylist(record.basicMajorSubclass);
        }
        // if (record.amount == "1") {
        //   this.ifirst = true;
        // } else {
        //   this.ifirst = false;
        //   this.form.content = "";
        // }
        // if (record.achievementType == "SZKC") {
        //   this.ishow = true;
        // } else {
        //   this.ishow = false;
        //   this.form.courseType = "";
        // }
        //       if (record.content!='' && record.content!=null ){
        //           this.$nextTick(() => {
        //             this.$refs.baseEditor[0].value = record.content;
        //           })
        //       }
      }
      this.$forceUpdate();
    },
    handleCancel() {
      this.visible = false;
      //this.yearShowOne = false;
    },
    getxwlist() {
      getAction("/baseCommon/getDictItemsByCode?code=achievement_level").then(
        (res) => {
          if (res.code == 200) {
            this.jblist = res.result;
          }
        }
      );
    },
    getcgjb() {
      // this.jblist = [
      //   {
      //     value: "思政精品课程",
      //     title: "思政精品课程",
      //   },
      //   {
      //     value: "思政示范课堂",
      //     title: "思政示范课堂",
      //   },
      //   {
      //     value: "思政教育示例",
      //     title: "思政教育示例",
      //   },
      //   {
      //     value: "课程思政示范课",
      //     title: "课程思政示范课",
      //   },
      //   {
      //     value: "课程思政教育案例",
      //     title: "课程思政教育案例",
      //   },
      //   {
      //     value: "课堂革命教育案例",
      //     title: "课堂革命教育案例",
      //   },
      //   {
      //     value: "思政大教研活动",
      //     title: "思政大教研活动",
      //   },
      //   {
      //     value: "思政教研与研究",
      //     title: "思政教研与研究",
      //   },
      //   {
      //     value: "思政育人实践活动",
      //     title: "思政育人实践活动",
      //   },
      //   {
      //     value: "其他",
      //     title: "其他",
      //   },
      // ];
      getAction("/baseCommon/getDictItemsByCode?code=" + this.code).then(
        (res) => {
          if (res.code == 200) {
            this.jblists = res.result;
          }
        }
      );
    },
    getkclist() {
      getAction("/baseCommon/getDictItemsByCode?code=apply_course_type").then(
        (res) => {
          if (res.code == 200) {
            this.kclist = res.result;
          }
        }
      );
    },
    submit() {
      //this.$refs.ruleForm.clearValidate();
      // console.log(typeof this.form.activityYear);
      if (this.disabled) {
        this.visible = false;
        return false;
      }
      if (
        typeof this.form.activityYear == "object" &&
        this.form.activityYear != "" &&
        this.type == "add"
      ) {
        this.form.activityYear =
          new Date(this.form.activityYear).getFullYear() + "";
      }
      console.log(this.form, "3333", this.$refs.ruleForm);
      this.$refs.ruleForm.validate((valid) => {
        console.log(valid, "4444");
        if (valid) {
          // this.yearShowOne = false;
          if (this.type == "add") {
            let params = this.form;
            //params.activityYear=new Date(this.form.activityYear).getFullYear()+"";
            params.applyType = this.applyType;
            // params.applyId = "1829722136428707841";
            postAction("/lxBase/lxApplyActivity/add", params).then((res) => {
              if (res.code == 200) {
                this.visible = false;
                this.$message.success("添加成功");
                this.$emit("addGain");
              } else {
                this.$message.error(res.message);
              }
            });
          } else if (this.type == "audit-edit") {
            let params = {
              taskId: this.taskId,
              afterJson: JSON.stringify({ ...this.form }),
              detailId: this.detailId,
            };
            postAction("/audit/lxAuditTask/reSubmitTask", params).then(
              (res) => {
                if (res.code == 200) {
                  this.visible = false;
                  this.$message.success(res.message || "编辑成功");
                  this.$emit("addGain");
                } else {
                  this.$message.error(res.message);
                }
              }
            );
          } else {
            if (
              this.teacherdata?.status == "0" ||
              this.teacherdata?.status == "1" ||
              this.teacherdata?.status == "4" ||
              this.teacherdata?.status == "3" ||
              (this.teacherdata?.status == "2" && this.teacherdata?.operation)
            ) {
              let params1 = this.form;
              // params.applyId = "1829722136428707841";
              if (typeof this.form.activityYear == "object") {
                params1.activityYear =
                  new Date(this.form.activityYear).getFullYear() + "";
              }
              params1.applyType = this.applyType;
              let params = {
                id: this.teacherdata?.taskId,
                applicationData: JSON.stringify(this.$nullToEmpty(params1)),
              };
              if (this.teacherdata?.status == "4") {
                params.auditState = "1";
              }
              putAction("/audit/lxAuditTask/editTaskAndDetail", params).then(
                (res) => {
                  if (res.code == 200) {
                    this.visible = false;
                    this.$message.success("编辑成功");
                    this.$emit("addGain");
                  } else {
                    this.$message.error(res.message);
                  }
                }
              );
            } else {
              let params = this.form;
              // params.applyId = "1829722136428707841";
              if (typeof this.form.activityYear == "object") {
                params.activityYear =
                  new Date(this.form.activityYear).getFullYear() + "";
              }
              params.applyType = this.applyType;
              putAction("/lxBase/lxApplyActivity/edit", params).then((res) => {
                if (res.code == 200) {
                  this.visible = false;
                  this.$message.success("编辑成功");
                  this.$emit("addGain");
                } else {
                  this.$message.error(res.message);
                }
              });
            }
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .ant-modal-title {
  text-align: center;
}

/deep/ .ant-input-number-handler-wrap {
  display: none;
}

.ipt-other {
  margin-left: 12px;
}
</style>